import EntityService from '@/services/EntityService'
import FirebaseService from '@/services/FirebaseService'
import { doc, getDoc } from 'firebase/firestore'

export class EmailTemplate {
  html: string
  label: string
  name: string
  partial: boolean
  subject: string
  text: string

  constructor () {
    this.html = ''
    this.label = ''
    this.name = ''
    this.partial = false
    this.subject = ''
    this.text = ''
  }
}

export default class EmailService extends EntityService<EmailTemplate> {
  constructor() {
    super({ collectionName: 'emailTemplates' })
  }

  /**
   * Find a record by id
   *
   * @param id
   * @returns Promise<T>
   */
  public async find(id: string) {
    const db = await FirebaseService.firestore()
    const docRef = doc(db, this.collectionName, id)
    const record = (await getDoc(docRef)).data()

    return record as EmailTemplate
  }
}
